<div (click)="clicked()" [attr.data-component-id]="subService.dataComponentId" class="systembar-sub-service-tab-item_item-wrapper">
  <div class="systembar-sub-service-tab-item_hover-effect">
    <div [ngClass]="subService.selected ? 'systembar-sub-service-tab-item_selected-indicator' : 'systembar-sub-service-tab-item_indicator'"></div>
    <div class="systembar-sub-service-tab-item_info-wrapper">
      <celum-icon class="systembar-sub-service-tab-item_celum-icon" [configuration]="subService.iconConfiguration"></celum-icon>
      <span class="systembar-sub-service-tab-item_icon-text">{{ subService.text | translate }}</span>
    </div>
  </div>
</div>
